import RoomSharp from '@mui/icons-material/RoomSharp';

const PointIcon = (): JSX.Element => <RoomSharp fontSize="inherit" />;

export default PointIcon;
